module.exports = __webpack_public_path__ + "static/media/taimalishan_plant.34644035.webp";